import { NX_SCHOOL_DISTRICT } from '@env/environment';

export function addUrlScheme(url: string) {
  return url.startsWith('http') ? url : `http://${url}`;
}

export const isPROD = () => process.env.NX_ADOBE_ANALYTICS_ENV === 'production';

export function getCourseHeroImageURL(course) {
  return course.assets?.images?.hero?.largeURL;
}

export const isSchoolDistrictDialogEnabled = () => NX_SCHOOL_DISTRICT === 'true';

export const getParentSubjects = (subjects) => subjects.filter(({ parentID }) => !parentID);

export const getProductIconURL = (product) => product.iconProps?.[2]?.url;
